/*
 * Module for handling campaign launch action
 */

define([
  "marionette",
  "i18n/i18n",
  "messaging/messenger",
  "moment-timezone",
  "./campaignScheduleModalView",
  "../campaignModel",
], function (Marionette, i18next, Messenger, Moment, CampaignScheduleModalView, CampaignModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "campaignScheduleModal";
      this.namespace = options.namespace;
      this.region = options.region;
    },
    show: function (options) {
      const { campaign, targetStateId, scheduleTargetStatuses } = options;
      this.campaign = campaign;
      this.targetStateId = targetStateId;
      this.allCampaignJobs = campaign.getAllCampaignJobs();

      const kbModel = Messenger.reqres.request("active:kb:model");
      campaign.versionedKb = kbModel.get("responseVersioning");
      campaign.targetStateId = targetStateId;
      campaign.targetStatusTranslation = i18next.t(scheduleTargetStatuses.get(targetStateId));

      this.view = new CampaignScheduleModalView.campaignScheduleModalView({ model: campaign });

      this.view.on("cancel", () => Messenger.vent.trigger("close:modal"));

      this.view.on("schedule:campaign", this._scheduleCampaign, this);

      this.allCampaignJobs.onSynced(() => {
        this.showRegion(this.view);
      });
    },
    scheduleError: function (errorMessage) {
      this.view.scheduleError(errorMessage);
    },
    _scheduleCampaign: async function () {
      const date = this.view.getDate();
      if (!date) {
        this.scheduleError(i18next.t("admin.campaigns.campaign.emptyDateError"));
        return false;
      }
      const timeStr = this.view.getTime();
      if (!timeStr) {
        this.scheduleError(i18next.t("admin.campaigns.campaign.emptyTimeError"));
        return false;
      }
      const time = this._getMilliseconds(timeStr);
      const timestamp = new Date(date.getTime() + time);
      const now = new Date();
      if (timestamp < now) {
        this.scheduleError(i18next.t("admin.campaigns.campaign.dateTimeInPastError"));
        return false;
      }
      this.view.clearErrors();
      const user = Messenger.reqres.request("user");
      const campaignSchedule = this.allCampaignJobs.addCampaignSchedule({
        campaignId: this.campaign.get("id"),
        stateId: this.targetStateId,
        userId: user.get("userId"),
        scheduledTimestamp: timestamp,
        jobStatus: CampaignModel.JOBRUNR_JOBS_STATUSES.SCHEDULED,
      });
      Messenger.vent.trigger("show:saving:display");
      try {
        await campaignSchedule.saveModelPromise();
        Messenger.vent.trigger("update:launch:area");
      } catch (errorMsg) {
        this.allCampaignJobs = this.campaign.getAllCampaignJobs({ forceFetch: true });
        console.error("Could not schedule campaign", errorMsg);
        Messenger.okDialog(errorMsg);
      } finally {
        Messenger.vent.trigger("close:saving:display");
        Messenger.vent.trigger("close:modal");
      }
    },
    _getMilliseconds: function (timeStr) {
      // Extract hours and minutes from the time string (HH:MM) which is in 24-hr format
      const time = Moment(timeStr, "HH:mm");
      if (!time.isValid()) {
        throw new Error("Invalid time format");
      }
      return time.diff(Moment().startOf("day"));
    },
  });
});
